import { ITermCourse } from '../../interfaces/scheduler_interfaces';
import { IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ISectionsDatasource } from '../../views/sections/datasources/sections_datasource';

export type ResetCoreqSectionsMetasourceCommand = (courseId: ITermCourse['id']) => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .factory(
    'resetCoreqSectionsMetasourceCommand',
    (defineCommandORM: IDefineCommand, ngSectionsDatasource: ISectionsDatasource) =>
      defineCommandORM('resetCoreqSectionsMetasourceCommand', (deferred, courseId: ITermCourse['id']) => {
        if (!courseId) {
          return;
        }
        const matchedSections = _4.filter(ngSectionsDatasource.read(), (section) => {
          return section.course === courseId ? true : _4.includes(section._course.coreq, courseId);
        });
        ngSectionsDatasource.write(matchedSections);
        deferred.resolve();
      })
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/search_and_add_courses/commands/reset_coreq_sections_metasource_command.ts